import {Component} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {PageService} from '../../services/page.service';
import {Page} from '../../models';

@Component({
  selector: 'app-content-page',
  templateUrl: './content-page.component.html',
  styleUrls: ['./content-page.component.css']
})
export class ContentPageComponent {
  public language = 'en';
  public page: Page;
  public multiColumn = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pageService: PageService,
  ) {
    // @ts-ignore
    router.events.subscribe( (event: Event) => {
      if (event instanceof NavigationEnd) {
        this.loadPage();
      }
    });
  }

  public loadPage() {
    this.route.url.subscribe(url => {
      this.language = url[0].path;
      const pageID = url[1].path;
      this.pageService.get(pageID, {lang: this.language}).subscribe(page => {
        this.page = page;
        if (this.page.columns.length > 1) {
          this.multiColumn = true;
        }
      });
    });
  }
}
